import dotenv from "dotenv";
import firebase from 'firebase/app';
import ReactGA from 'react-ga';

if (process.env.NODE_ENV === "production") {
  dotenv.config({ path: `/../.env.production` });
} else {
  dotenv.config({ path: `/../.env` });
}

export const paymentApiURL = process.env.REACT_APP_PAYMENT_API_URL;
export const notificationApiURL = process.env.REACT_APP_NOTIFICATIONS_API_URL

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);

const config = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};
firebase.initializeApp(config)

// window.$crisp = [];
// window.CRISP_WEBSITE_ID = "8a0ef439-8fa0-4840-bd83-5a280d873944";
// (function () {
//   var d = document;
//   var s = d.createElement("script");
//   s.src = "https://client.crisp.chat/l.js";
//   s.async = true;
//   d.getElementsByTagName("head")[0].appendChild(s);
// })();
const script = document.createElement('script');
  
    script.src = './activeCampaing.js';
    script.async = true;
  
    document.body.appendChild(script);